import { WppButton, WppModal, WppTypography } from '@wppopen/components-library-react'
import modalStyles from '../Modal.module.scss'

interface UnsavedChangesModalProps {
  handleSubmit: () => void
  onCancel: () => void
  shouldModalOpen: boolean
}

export default function UnsavedChangesModal({ handleSubmit, onCancel, shouldModalOpen }: UnsavedChangesModalProps) {
  return (
    <WppModal
      open={shouldModalOpen}
      className={modalStyles.modal}
      formConfig={{
        onSubmit: e => {
          e.preventDefault()
          handleSubmit()
        },
        onReset: () => {
          onCancel()
        },
      }}
      data-testid="unsaved-changes-modal"
    >
      <WppTypography tag="h3" type="xl-heading" slot="header">
        Unsaved edits
      </WppTypography>
      <div slot="body">
        <WppTypography tag="p" type="s-body" data-testid="modal-disclaimer">
          Are you sure you want to leave this page?
          <br />
          You have unsaved changed that you will lose.
        </WppTypography>
      </div>

      <div slot="actions">
        <div className={modalStyles.modal__actionsGroup}>
          <WppButton type="reset" variant="secondary" data-testid="modal-cancel-button">
            Cancel
          </WppButton>
          <WppButton type="submit" variant="primary" data-testid="modal-submit-button">
            Leave page
          </WppButton>
        </div>
      </div>
    </WppModal>
  )
}
